import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './routes/App';
import reportWebVitals from './reportWebVitals';
import './interceptors/axios';
import { Provider } from 'react-redux';
import amalStore from './store';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Bag from './routes/Bag';
import Home from './routes/Home';
import PlaceOrder from './routes/PlaceOrder';
import SignUp from './routes/SignUp';
import AddressUpdate from './routes/AddressUpdate';
import PlacedOrderSuccessfully from './routes/PlacedOrderSuccessfully';
import './config';
import HomeServices from './routes/HomeServices';
import Hotels from './routes/Hotels';
import Shop from './routes/Shop';
import ShoptItemDetails from './routes/ShoptItemDetails';
import YourProfile from './routes/YourProfile';
import YourOrders from './routes/YourOrders';

const router = createBrowserRouter([{
  path: "/",
  element: <App />,
  children: [
    { path: "/", element: <Home />/*, Loader: postLoader*/ },
    {
      path: "/bag",
      element: <Bag />,
      /*action: createPostAction,*/

    },
    {
      path: "/place-order", element : <PlaceOrder />
    },
    {
      path: "/sign-up", element : <SignUp />
    },
    {
      path: "/address-update", element : <AddressUpdate />
    },
    {
      path: "/placed-order-successfully", element : <PlacedOrderSuccessfully />
    },
    {
      path: "/home-services", element : <HomeServices />
    },
    {
      path: "/hotels", element : <Hotels />
    },
    {
      path: "/shop", element : <Shop />
    },
    {
      path:"/shop-item-details", element : <ShoptItemDetails />
    },
    {
      path:"/your-profile", element : <YourProfile />
    },
    {
      path:"/your-orders", element : <YourOrders />
    },
  ],

},
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={amalStore}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
